import { render } from "./VoteModal.vue?vue&type=template&id=95716a64"
import script from "./VoteModal.vue?vue&type=script&lang=js"
export * from "./VoteModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__